export default "__VITE_ASSET__B3N5ttMM__"